/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.gen.ai.skills.rpc.IndustryUseCaseRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './IndustryUseCaseRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.gen.ai.skills.rpc.IndustryUseCaseRpc#generateIndustryUseCase
 */
export const GENERATE_INDUSTRY_USE_CASE_QUERY_FIELD_NAME = 'com_hubspot_academy_gen_ai_skills_rpc_IndustryUseCaseRpc_generateIndustryUseCase';
export const GENERATE_INDUSTRY_USE_CASE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GENERATE_INDUSTRY_USE_CASE_QUERY_FIELD_NAME,
  args: ['videoPortalId', 'videoId', 'industry'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.generateIndustryUseCaseRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});